import * as t from 'io-ts';

export const CargoTypeInformationImageDynamicType = t.type({
    displayName: t.union([t.string, t.null]),
    url: t.string,
});

export const CargoTypeInformationDynamicType = t.type({
    name: t.union([t.string, t.null]),
    description: t.string,
    images: t.array(CargoTypeInformationImageDynamicType),
});

export type CargoTypeInformation = t.TypeOf<typeof CargoTypeInformationDynamicType>;
